// @flow
import React from 'react';
import {compose} from 'redux';
import {graphql} from 'react-apollo';
import {connect} from 'react-redux';
import translationsQuery from '../../queries/translationsQuery';

import type {ComponentType} from 'react';
import type {Bundle} from '../../queries/translationsQuery';
import type {State as ReduxState} from '../../reducers/index';

type StateProps = {
    locale: string
};

export type LinguaProps = {
    locale: string,
    messages: Object,
    isLinguaLoading: boolean
};

type ConnectorProps = {
    data: {
        loading: boolean,
        translations: {
            messages: Object
        }
    }
} & StateProps;

const withLingua = (bundle: Bundle) => <OwnProps: LinguaProps>(
    WrappedComponent: ComponentType<$Supertype<OwnProps>>
): ComponentType<$Diff<OwnProps, LinguaProps>> => {
    type Props = OwnProps & ConnectorProps;

    const WithLingua = ({data, ...rest}: Props) => (
        <WrappedComponent
            messages={data.translations ? data.translations.messages : {}}
            isLinguaLoading={data.loading}
            {...rest}
        />
    );

    const mapStateToProps = ({
        system: {fullLocale}
    }: ReduxState): StateProps => ({
        locale: fullLocale
    });

    return compose(
        connect(mapStateToProps),
        graphql(translationsQuery, {
            options: ({locale}) => {
                return {variables: {locale, bundle}};
            }
        })
    )(WithLingua);
};

export default withLingua;
